import buildPrintDocument from './buildPrintDocument';
import captureDisplaySetImages from './captureDisplaySetImages';
import getPrintHeader from './getPrintHeader';
import openPrintSheet from './openPrintSheet';

/** Sheets beyond this count require an explicit confirmation from the user. */
export const MAX_PAGES_WITHOUT_CONFIRM = 10;

export function getSeriesGrid(imageCount) {
  if (imageCount <= 1) {
    return { columns: 1, rows: 1 };
  }
  if (imageCount <= 4) {
    return { columns: 2, rows: 2 };
  }
  return { columns: 4, rows: 5 };
}

export {
  buildPrintDocument,
  captureDisplaySetImages,
  getPrintHeader,
  openPrintSheet,
};
